export class ElementDictionary{
    columnId:string;
    subElement: any;
}